import { render, staticRenderFns } from "./customer-assets.vue?vue&type=template&id=5a091d1e&"
import script from "./customer-assets.vue?vue&type=script&lang=js&"
export * from "./customer-assets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports